import { useState, forwardRef } from 'react';
import {
  FormControl,
  Select,
  MenuItem,
  ListItemText,
  Typography
} from '@mui/material';

interface WorkModelTypeMultiSelectProps {
  value: string,
  onChange: (e: any) => void,
  disabled?: boolean,
  required?: boolean,
}

const WorkModelTypeDropdown = forwardRef((props: WorkModelTypeMultiSelectProps, _ref) => {
  const [types] = useState(['Permanent WFH', 'Hybrid', 'In Office']);

  return (
    <FormControl fullWidth  disabled={props?.disabled ? props?.disabled : false}>
      <Typography fontWeight="light" variant="h5">
        Work Model{props?.required && <span style={{ color: 'red' }}>*</span>}
      </Typography>
      <Select
        id="filter-resource"
        sx={{ mt: 1 }}
        style={{
          fontSize: '12px',
          height: '2rem'
        }}
        displayEmpty
        size="small"
        value={props?.value}
        onChange={(e) => props?.onChange(e)}
      >
        <MenuItem
          style={{ display: 'none' }}
          selected
          disabled
          value={''}
        >
          Select Work Model
        </MenuItem>
        {
          types?.length > 0 &&
          types.map((type, i) => {
            return (
              <MenuItem key={i} 
                value={type.toUpperCase().replace(' ', '_')}>
                  <ListItemText primary={type} />
              </MenuItem>
            );
          })
        }
      </Select>
    </FormControl>
  );
});

export default WorkModelTypeDropdown;
